/* Dogs Supreme — DS Upsell Rotator
 * Laesst EINE Benefit-Zeile durch die Upsell-Bullets rotieren (statt einem mehrzeiligen Block).
 * Genutzt auf der /cart-Seite (main-cart.liquid) UND im Cart-Drawer (ds-cart-upsell.js).
 *
 * Erwartet pro Upsell: <div data-upsell-rotator data-bullets='["...","..."]'><span class="dsu__rot-line">...</span></div>
 * - <2 Bullets oder prefers-reduced-motion: statisch (erste Zeile, keine Animation)
 * - pausiert wenn Tab im Hintergrund (visibilitychange via document.hidden)
 * - idempotent (kein Doppel-Start), re-scannt bei cart:rendered / ajaxProduct:added (Drawer)
 */
(function () {
  'use strict';

  var INTERVAL = 2600;   // ms pro Bullet
  var FADE = 360;        // ms Fade (muss zur CSS-Transition passen)
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start(el) {
    if (!el || el._dsRot) return;                 // idempotent
    var line = el.querySelector('.dsu__rot-line');
    if (!line) return;
    var bullets;
    try { bullets = JSON.parse(el.getAttribute('data-bullets') || '[]'); } catch (e) { bullets = []; }
    bullets = (bullets || []).filter(function (b) { return b && String(b).trim(); });
    if (bullets.length < 2 || reduce) { el._dsRot = true; return; }  // statisch

    var i = 0;
    el._dsRot = setInterval(function () {
      if (document.hidden) return;                // im Hintergrund nicht wechseln
      line.style.opacity = '0';
      setTimeout(function () {
        i = (i + 1) % bullets.length;
        line.textContent = bullets[i];
        line.style.opacity = '1';
      }, FADE);
    }, INTERVAL);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('[data-upsell-rotator]');
    for (var k = 0; k < list.length; k++) start(list[k]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Drawer injiziert Upsell dynamisch -> nach Cart-Render erneut scannen
  document.addEventListener('cart:rendered', function () { scan(); });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(scan, 400); });

  // Neu eingefuegte Rotatoren (Drawer/AJAX) automatisch starten
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var nodes = muts[m].addedNodes;
        for (var n = 0; n < nodes.length; n++) {
          var node = nodes[n];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-upsell-rotator]')) start(node);
          else if (node.querySelector) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.dsUpsellRotator = { scan: scan, start: start };
})();
